import { TextField } from "@mui/material";
import MDBox from "components/MDBox";
import { PERIOD_OPTIONS } from "utils/periodOptions";

export const SearchSelectionBox = ({searchOption, searchOptionHandler, id = "addActivityStatus"}) => {
  return (<MDBox>
    <TextField
      sx={{
        width: "170px",
      }}
      select
      label="Period"
      id={id}
      helperText="*Required"
      onChange={searchOptionHandler}
      SelectProps={{
        native: true,
      }}
      value={searchOption}
    >
      {PERIOD_OPTIONS.map(({ value, label }) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </TextField>
  </MDBox>);
};
